<template>
    <div class="notification-banner-wrapper"
        :class="bannerClasses">

        <div class="content">
            <div class="icon">
				<slot name="icon">
					<img
						:src="require(`@/assets/img/${iconSrc}`)"
						class="success-icon"
					>
				</slot>
            </div>

            <div class="message">

                <div class="header">
                    <slot name="header">
						<span>
							{{ $t(title) }}
						</span>
					</slot>
                </div>

				<slot name="message">
					<p>{{ $t(message) }}</p>
				</slot>
            </div>

			<slot name="action">
				<div class="close">
					<span @click="close()">&times;</span>
				</div>
			</slot>

        </div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
	computed: {
		...mapGetters('banner', {
			status: 'getBannerStatus',
			message: 'getBannerMessage',
			type: 'getBannerType'
		}),

		bannerClasses () {
			return [{
				'closing': this.isClosing
			}, this.type]
		},

		title () {
			const titles = {
				success: 'success',
				warning: 'warning_watch_out',
				failed: 'error_something_wrong',
				error: 'action_invalid'
			}

			return titles[this.type]
		},

		iconSrc () {
			const icons = {
				success: 'ic_success.png',
				warning: 'ic_warning.png',
				error: 'ic_error.png'
			}

			return icons[this.type]
		}
	},

	data () {
		return {
			isClosing: false
		}
	},

	mounted () {
		setTimeout(() => this.autoClose(), 3000)
	},

	methods: {
		autoClose () {
			if (!this.isClosing) {
				this.isClosing = true
				setTimeout(() => {
					this.$store.dispatch('banner/toggleBanner', { status: false })
				}, 1000)
			}
		},

		close () {
			this.autoClose()
		}
	}
}
</script>

<style lang="scss" scoped>
.notification-banner-wrapper {
    position: fixed;
    top: 60px;
    right: 0;
    left: 0;
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 10px;
    z-index: 999;
    pointer-events: none;

    .content {
        position: relative;
        display: flex;
        align-items: center;
        background: #fff;
        box-shadow: 0 0 24px rgba(0,0,0,0.15);
        border-radius: 5px;
        width: 465px;
        padding: 10px;
        pointer-events: all;

        animation-name: animate-fade-in-right;
        animation-duration: 0.5s;
        animation-delay: 0s;
        animation-fill-mode: forwards;
        animation-timing-function: ease-in-out;

        .icon {
            padding: 0 5px;

            img {
                width: 24px;
                height: auto;
            }
        }

        .message {
            flex: 1 1 auto;
            padding: 0 20px;

            .header {
                span {
                    font-size: 16px;
                    font-weight: 700;
                    color: #4A4C50;
                }
            }

            p {
                margin-top: 5px;
                font-size: 14px;
                font-style: italic;
                color: #979CAC;
            }
        }

        .close {
            padding: 10px;
            cursor: pointer;

            span {
                color: #979CAC;
                font-size: 24px;
            }
        }
    }

    &.success {
        .content {
            border-left: 10px solid #29C27C;
        }
    }

    &.warning {
        .content {
            border-left: 10px solid #F8C51B;
        }
    }

    &.failed {
        .content {
            border-left: 10px solid #f54b5e;
        }
    }

    &.closing {
        .content {
            animation-name: animate-fade-in-right;
            animation-duration: 0.5s;
            animation-delay: 0s;
            animation-fill-mode: forwards;
            animation-timing-function: ease-in-out;
        }
    }

    @keyframes animate-fade-in-right{
        from{
            transform: translateX(50px);
            opacity: 0;
        }
        to{
            transform: translateX(0px);
            opacity: 1;
        }
    }

    @keyframes animate-fade-out-right{
        from{
            transform: translateX(0px);
            opacity: 1;
        }
        to{
            opacity: 0;
            transform: translateX(50px);
        }
    }

}
</style>
